import axios from 'axios';

interface RecipientDetailsPayload {
  phone_number: string;
  dealId?: string;
  personId?: string;
}

/**
 * Sends recipient details to the API endpoint
 * @param currentRecipient - The current recipient object with phone_number (can be string or number)
 * @param token - Authentication token
 * @returns Promise<void>
 */
export const sendRecipientDetails = async (
  currentRecipient: { phone_number: string | number },
  token: string
): Promise<void> => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const resource = urlParams.get('resource');
    const view = urlParams.get('view');
    const selectedIds = urlParams.get('selectedIds');
    
    const recipientPayload: RecipientDetailsPayload = {
      phone_number: String(currentRecipient.phone_number)
    };

    // Check URL parameters and add appropriate ID
    if (resource === 'deal' && view === 'details' && selectedIds) {
      recipientPayload.dealId = selectedIds;
    } else if (resource === 'person' && view === 'details' && selectedIds) {
      recipientPayload.personId = selectedIds;
    }

    // Send POST request to recipient details endpoint
    await axios.post('https://api.insightssystem.com/api:MLBAaPmt/recipient/details', recipientPayload, {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: token })
      }
    });
  } catch (error: any) {
    // Log error but don't throw - this is a non-critical operation
    console.error('Failed to send recipient details:', error);
    // Return void - let the calling function handle any specific error handling
  }
};
